import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { copyToClipboard } from './utils';

interface CopyButtonProps {
  value: string;
  className?: string;
  iconClassName?: string;
}

export const CopyButton = ({ value, className, iconClassName = "w-3 h-3" }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation(); // prevent drag/drop triggers
    copyToClipboard(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={handleCopy}
      className={className || "p-1 h-6 w-6 bg-transparent border-0 flex-shrink-0 text-muted-foreground hover:text-foreground hover:bg-accent"}
    >
      {copied ? <Check className={`${iconClassName} text-emerald-500`} /> : <Copy className={iconClassName} />}
    </Button>
  );
};
